module.exports = __webpack_public_path__ + "img/cranberry-havermoutmuffins.e6f6dd21.jpeg";